import { initializeWebAnalytics } from "./metrics";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./fonts.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

initializeWebAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App /> {/* Appコンポーネントをレンダリング */}
  </React.StrictMode>
);

// アプリのパフォーマンスを測定する場合は、結果を記録するための関数を渡す
// （例: reportWebVitals(console.log)）
// または、分析エンドポイントに送信する。詳細はこちら: https://bit.ly/CRA-vitals
reportWebVitals();
